import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecurityAuditSecretsWithReportGroups } from '../services/selectors';

export const useSecurityAuditReportSecretsList = () => useAppSelector(selectSecurityAuditSecretsWithReportGroups);
